/**
 * DataTables column `data` keys for `POST /api/admin/freightFormRequest/data`.
 * Order must match the server-side column index used in `order[0][column]`.
 * `created_at` is index 12 per API examples (`columns[12][data]=created_at`).
 */
export const FREIGHT_FORM_REQUEST_DT_COLUMN_ORDER = [
  "id",
  "type",
  "rm_name",
  "rm_mobile_no",
  "master_name",
  "master_code",
  "normal_name",
  "user_mobile_no",
  "from_location",
  "to_location",
  "qty",
  "loading_date",
  "created_at",
  "material_type_name",
  "remarks",
  "status",
  "action",
  "changeStatus"
];

export function freightFormRequestDtColumnsPayload() {
  return FREIGHT_FORM_REQUEST_DT_COLUMN_ORDER.map((data) => ({
    data,
    name: data,
    searchable: true,
    orderable: true,
    search: { value: "", regex: false }
  }));
}

/**
 * @param {object} p
 * @param {number} p.draw
 * @param {number} p.start
 * @param {number} p.length
 * @param {string} p.searchValue
 * @param {string} [p.sortBy] column `data` key
 * @param {'asc'|'desc'} [p.sortDir]
 */
export function buildFreightFormRequestDataTablesBody({
  draw,
  start,
  length,
  searchValue = "",
  sortBy,
  sortDir = "desc"
}) {
  const columns = freightFormRequestDtColumnsPayload();
  let orderColumn = FREIGHT_FORM_REQUEST_DT_COLUMN_ORDER.indexOf("created_at");
  if (sortBy && FREIGHT_FORM_REQUEST_DT_COLUMN_ORDER.includes(sortBy)) {
    orderColumn = FREIGHT_FORM_REQUEST_DT_COLUMN_ORDER.indexOf(sortBy);
  }
  const dir = sortDir === "asc" ? "asc" : "desc";
  return {
    draw,
    start,
    length,
    search: { value: searchValue || "", regex: false },
    order: [{ column: orderColumn, dir }],
    columns
  };
}
